var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6685 3.91466C14.7441 3.27196 15.0574 2.68079 15.5468 2.2573C16.0361 1.83381 16.6661 1.6086 17.313 1.62593C17.9599 1.64326 18.577 1.90187 19.0429 2.35095C19.5089 2.80003 19.7901 3.40712 19.8312 4.05295",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64941 11.9123L4.28583 24.243C4.36662 24.8337 4.6586 25.375 5.10775 25.767C5.5569 26.1589 6.13282 26.3749 6.72894 26.375H18.5527C19.1488 26.3749 19.7247 26.1589 20.1738 25.767C20.623 25.375 20.915 24.8337 20.9958 24.243L22.4939 12.984L22.6322 11.9123",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6322 11.9123C21.4294 12.3581 20.1972 12.72 18.9445 12.9955C17.6363 13.2957 16.3072 13.496 14.9687 13.5948C14.2081 13.6639 13.4244 13.6985 12.6638 13.6985H12.4564C11.3003 13.6936 10.1457 13.6166 8.99919 13.468C7.52511 13.2874 6.06824 12.9868 4.64308 12.5691C3.99773 12.3848 3.34086 12.1543 2.64941 11.9123",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8263 17.732H7.45459V22.3416H17.8263V17.732Z",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03352 13.4682C7.55945 13.2876 6.10257 12.987 4.67742 12.5694L2.0845 7.75229C1.68591 7.01839 1.5943 6.15648 1.82971 5.35519C2.06513 4.55391 2.6084 3.87852 3.34062 3.47686C3.80165 3.23016 4.31588 3.09962 4.83875 3.09656C5.41392 3.09196 5.97949 3.24397 6.47485 3.53631C6.9702 3.82865 7.37665 4.25029 7.65063 4.75603L9.32162 7.84448L12.4562 13.6757",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3756 6.79565C12.329 6.45377 12.3524 6.106 12.4444 5.77344C12.5363 5.44088 12.6948 5.13047 12.9104 4.86105C13.1259 4.59163 13.394 4.36881 13.6982 4.20612C14.0025 4.04343 14.3366 3.94426 14.6804 3.91462",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8318 4.0529C20.1136 3.95569 20.4095 3.90509 20.7076 3.90309C21.286 3.9109 21.8452 4.11188 22.2962 4.47406C22.7472 4.83625 23.0641 5.33884 23.1966 5.90189C23.3291 6.46495 23.2695 7.05613 23.0273 7.58142C22.7851 8.10671 22.3742 8.53594 21.86 8.80083",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8936 8.80083C22.2612 8.99033 22.5782 9.26504 22.818 9.60201C23.0578 9.93899 23.2136 10.3284 23.2722 10.7379C23.3309 11.1473 23.2907 11.5648 23.1551 11.9556C23.0196 12.3463 22.7925 12.699 22.4928 12.9841",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7778 6.96868H4.94287",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18237 9.58438H6.62402",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32178 7.84447C10.0653 7.14816 11.0459 6.76086 12.0645 6.76121H12.3757C13.0681 6.81841 13.7338 7.05455 14.3076 7.44646C14.8813 7.83838 15.3434 8.37264 15.6485 8.99688C15.9453 9.56194 16.0996 10.1909 16.0979 10.8292C16.0934 11.8704 15.6795 12.868 14.9455 13.6065C16.6972 12.9266 18.0455 6.35787 18.0455 6.35787",
    stroke: "#81BC45",
    strokeWidth: 2.08391,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.d89e8ba2c41d0a9eb1480e37dfb95fa7.svg";
export { ForwardRef as ReactComponent };